import { render, staticRenderFns } from "./ProjectOffersListBox.vue?vue&type=template&id=8c706100&scoped=true"
import script from "./ProjectOffersListBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectOffersListBox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectOffersListBox.vue?vue&type=style&index=0&id=8c706100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c706100",
  null
  
)

export default component.exports